/**
 * Вернет какую локаль стоит отображать пользователю
 * с учетом языка браузера и доступных к использованию локалей
 *
 * Функция вернет русскую локаль, если не найдет нужную в доступных к использованию
 *
 * @returns {string}
 */
const getUserLocale = () => {
  const locale = navigator.language.toLowerCase().split('-')[0];
  if (locale === 'en' || locale === 'fr') {
    return locale;
  }

  return 'ru';
};

export const userLocale = getUserLocale();
